if ( jQuery(".rotate-text-contain").length ) {
    jQuery(".rotate-text-contain").each(function (index) {
        let container = jQuery(this);
        let textElements = container.find(".rotate-text");
    
        let tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
        });
    
        tl.fromTo(
            textElements,
            { rotateY: "-40deg" },
            { rotateY: "85deg", duration: 1, stagger: 0.07, ease: "power1.in" }
        )
        .to(
            textElements,
            { opacity: 1, duration: 0.25, delay: 0.2, stagger: 0.025 },
            "<"
        )
        .fromTo(
            container,
            { rotateX: "-43deg" },
            { rotateX: "43deg", ease: "none", duration: 1 },
            "<"
        );
    });
}

if ( jQuery(".rotate-text-contain-2").length ) {
    jQuery(".rotate-text-contain-2").each(function (index) {
        let container = jQuery(this);
        let textElements = container.find(".rotate-text");
    
        let tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
        });
    
        tl.fromTo(
            textElements,
            { rotateY: "-20deg" },
            { rotateY: "20deg", duration: 1, stagger: 0.07, ease: "power1.in" }
        )
        .to(
            textElements,
            { opacity: 1, duration: 0.25, delay: 0.2, stagger: 0.025 },
            "<"
        )
        .fromTo(
            container,
            { rotateX: "-43deg" },
            { rotateX: "43deg", ease: "none", duration: 1 },
            "<"
        );
    });
}

if ( jQuery(".wrapper-rotate-text-contain").length ) {
    jQuery(".wrapper-rotate-text-contain").each(function (index) {
        let container = jQuery(this);
        let textElements = container.find(".rotate-logo");
    
        let tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
        }
        });
    
        tl.fromTo(
            textElements,
            { rotateY: "-140deg" },
            { rotateY: "85deg", duration: 1, stagger: 0.07, ease: "power1.in" }
        )
        .to(
            textElements,
            { opacity: 1, duration: 0.25, delay: 0.2, stagger: 0.025 },
            "<"
        )
        .fromTo(
            container,
            { rotateX: "-43deg" },
            { rotateX: "43deg", ease: "none", duration: 1 },
            "<"
        );
    });
}